import React, { useState, useMemo } from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button, Modal, Input, } from "components"
import TdFormLevelModalItem from "./TdFormLevelModalItem"
import classes from "./TdFormLevelModal.module.scss"

const TdFormLevelModal = props => {
  const {
    form,
    setForm,
    tables,
    openModal,
    setOpenModal
  } = props

  const [t, i18n] = useTranslation()

  const [input, setInput] = useState("")

  const handleAdd = () => {
    if (!input.trim()) return

    setForm(prev => ({
      ...prev, level: input
    }))

    setOpenModal(false)

    setInput("")
  }

  const getLevelOptions = () => {
    const result = []

    tables.forEach(table => {
      !result.includes(table.level) &&
        result.push(table.level)
    })

    return result
  }

  const options = useMemo(() => {
    return getLevelOptions()
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={openModal}
      onHide={() => setOpenModal(false)}
    >
      <div className={classes["modal-container"]}>
        <div className={classes["close-icon"]}>
          <button
            onClick={() => setOpenModal(false)}
          >
            <MdClose size={18} />
          </button>
        </div>

        <div className={classes["row"]}>
          <Input
            value={input}
            placeholder={t("ایجاد_طبقه_جدید")}
            onChange={e => setInput(e.target.value)}
            className={clsx(
              classes["modal-search"],
              isLtr && classes["modal-search-ltr"]
            )}
          />
          <Button
            color="success"
            onClick={handleAdd}
          >
            {t("ایجاد")}
          </Button>
        </div>

        <div className={classes["title-level"]}>
          {t("طبقه_های_دیگر")}
        </div>

        {options.map(option =>
          <TdFormLevelModalItem
            key={option}
            item={option}
            setForm={setForm}
            setOpenModal={setOpenModal}
            isActive={form.level === option}
          />
        )}
      </div>
    </Modal>
  )
}

export default TdFormLevelModal